import { DieTypes } from "@/constants";
import { DiceOperations } from "@/enums";
import type { DiceNotation } from "@/types";

export const parseDiceNotation = (notation: string) => {
  const known_types = Object.values(DieTypes);
  const no = notation.split("@");
  const diceRegex =
    /\s*(\d*)d(\d+)((k[hl])(\d+))?(\s*(\+|\-)\s*(\d+)){0,1}\s*(\+|$)/gi;
  const ret: DiceNotation = {
    constant: 0,
    set: [],
  };
  let res: RegExpExecArray | null;

  // If the notation is just a number return as constant.
  if (!isNaN(Number(notation))) {
    ret.constant = Number(notation);
    return ret;
  }
  while ((res = diceRegex.exec(no[0]))) {
    const groups = {
      count: res[1],
      dieType: res[2],
      opModifier: res[4],
      opConstant: res[5],
      constantOperation: res[7],
      constant: res[8],
    };

    let count = parseInt(groups.count);
    if (groups.count === "") count = 1;

    const type = DieTypes[("d" + groups.dieType) as keyof typeof DieTypes];
    if (known_types.indexOf(type) === -1) {
      throw `Unknown die type ${type}`;
    }

    const term = {
      count,
      dieType: type,
      operation: DiceOperations.Sum,
      operand: 0,
      dice: [],
    };

    // Check for Keep Highest / Lowest
    if (groups.opModifier === "kh") {
      term.operation = DiceOperations.Max;
    } else if (groups.opModifier === "kl") {
      term.operation = DiceOperations.Min;
    }
    if (groups.opConstant) {
      term.operand = parseInt(groups.opConstant);
    }
    ret.set.push(term);

    if (groups.constant && groups.constantOperation) {
      if (groups.constantOperation === "+")
        ret.constant += parseInt(groups.constant);
      else ret.constant -= parseInt(groups.constant);
    }
  }
  if (ret.set.length < 1) {
    throw "No dice specified";
  }
  return ret;
};
